import LocalStorageService from '../../services/LocalStorageService'
import { userActionTypes, DefaultUserAction } from './userTypes'

const initialState = {
  isLoggedIn: !!LocalStorageService.getAuthToken(),
  isLoginLoading: false,
  isUserLoading: false,
}

export default (state = initialState, action: DefaultUserAction): typeof initialState => {
  switch (action.type) {
    case userActionTypes.LOGIN:
      return { ...state, isLoginLoading: true }
    case userActionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        isLoginLoading: false,
        isLoggedIn: true,
      }
    case userActionTypes.LOGIN_FAILURE:
      return {
        ...state,
        isLoginLoading: false,
        isLoggedIn: false,
      }
    case userActionTypes.LOGOUT_SUCCESS:
      return { ...state, isLoggedIn: false }

    default:
      return state
  }
}
